import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { PriceFilteringAction } from '@cbridge-packages/price-filtering-profile';

export const toggleViewPriceFilteringSidebarEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    PriceFilteringAction.update.done,
  ),
  map(() => {
    return DetailsSidebarAction.toggleEdit();
  }),
);
